<template>
    <data-view :tableColumns="tableColumns" :tableData="items" :actionButtons="actionButtons" titleKey="ClientName"
        @sortChanged="event => emit('sortChanged', event)"
        @loadMore="emit('loadMore')">
    </data-view>
</template>

<script setup>
import { ref } from 'vue'
import DataView from '@/views/app/components/DataView.vue'

const emit = defineEmits(['sortChanged', 'loadMore', 'edit', 'details'])

const props = defineProps({
    items: { type: Array, default: () => ([]) }
})

const tableColumns = ref([
    { key: 'ClientName', label: 'client', sortable: false },
    { key: 'gracePeriod', label: 'days', sortable: false }
])

const actionButtons = ref([
    { text: 'grace_period', icon: 'ClockIcon', color: 'warning', permissions: ['IU PREEXPENSES EDIT'], onClick: row => emit('edit', row) },
    { text: 'range', icon: 'CalendarIcon', color: 'primary', permissions: ['IU PREEXPENSES EDIT'], onClick: row => emit('details', row) }
])


</script>
